import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/inclusive';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    },
    map: {
        homepage_lms: {
            type: 'http',
            useLanguage: false,
        },
    }
};

export const InclusiveOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);
